<template>
  <div class="heart-field" id="heart">    
    <div class="hearts" >
    
      <div class="heart-wrapper heart-main">
        <svg xmlns="http://www.w3.org/2000/svg" width="78.587" height="59.094" viewBox="0 0 78.587 59.094">
          <g id="heart1" transform="translate(-3.736 -32.136)">
            <g id="Group_973" data-name="Group 973" transform="translate(3.736 32.136)">
              <path id="XMLID_2_" d="M76.335,37.334c-8.014-6.955-20.022-7.145-27.575.734-1.97,2.065-3.953,4.116-5.922,6.181-2.105-2.024-4.224-4.048-6.33-6.072-7.362-7.063-20.688-7.186-27.575.734-6.955,8.014-7.145,20.022.734,27.575q9.638,9.25,19.3,18.5A14.286,14.286,0,0,0,30,85.976c7.362,7.063,20.688,7.186,27.575-.734q9.739-10.167,19.492-20.335C84.132,57.533,84.254,44.207,76.335,37.334Z" transform="translate(-3.736 -32.136)" fill="#ec2227"/>
            </g>
          </g>
        </svg>
      </div>
    
      <div class="heart-wrapper heart-pulse">
        <svg xmlns="http://www.w3.org/2000/svg" width="78.587" height="59.094" viewBox="0 0 78.587 59.094">
          <g id="heart2" transform="translate(-3.736 -32.136)">
            <g id="Group_973" data-name="Group 973" transform="translate(3.736 32.136)">
              <path id="XMLID_2_" d="M76.335,37.334c-8.014-6.955-20.022-7.145-27.575.734-1.97,2.065-3.953,4.116-5.922,6.181-2.105-2.024-4.224-4.048-6.33-6.072-7.362-7.063-20.688-7.186-27.575.734-6.955,8.014-7.145,20.022.734,27.575q9.638,9.25,19.3,18.5A14.286,14.286,0,0,0,30,85.976c7.362,7.063,20.688,7.186,27.575-.734q9.739-10.167,19.492-20.335C84.132,57.533,84.254,44.207,76.335,37.334Z" transform="translate(-3.736 -32.136)" fill="#ec2227"/>
            </g>
          </g>
        </svg>
      </div>
      
    </div>
      
    <p class="instruction" id="opnieuw">KLIK OM TE HELPEN</p>
  </div>
</template>

<script>

  export default {
    name: 'click-heart',
    data(){
      return{

      }
    },
    mounted(){
      this.updateHeartPosition();
    },
    methods:{
      updateHeartPosition(){
      let scene = this.$parent.$options.name;
      let screenwidth =  document.body.clientWidth;

      let heart = document.getElementById("heart");

        if (screenwidth >= 900) {
          if (scene === "Scene1-yellow" | scene === "Scene2-yellow" | scene === "Scene3-yellow") {
        heart.classList.add("yellow-trans");
        // console.log("update heart")
         }else{ heart.classList.remove("yellow-trans"); }

        }
     
      }
    }
    }
</script>
<style scoped>
 .heart-field{
  /* border: dotted lime; */
cursor: pointer;
  position: absolute;
  z-index: 20;

  display: flex;
  flex-direction: column;
  align-items: center;

   left: 0; 
  right: 0;  
  margin-left: auto; 
  margin-right: auto;
  
  bottom: 10%;

  max-width: 140px;
  max-height: 100px;

  transform: scale(0.8);
  /* transition: all 0.3s ease-in-out; */
  }

.heart-pulse{
  margin: 0px;
  margin-top: -66px;
  opacity: 0;
  animation: opacity 1.5s  ease-in-out 2s infinite;
}

.instruction{
    text-align: center;
    margin-top: 5px;
    position: relative;
    z-index: 10;

    font-size: 11px;
    font-weight: 700;

    opacity: 0;
    animation: appear 1.5s ease-in-out 2.1s forwards;
  }



  @keyframes opacity{
    0%{
      opacity: 0;
      transform: scale(1,1);
    }
  
    50%{opacity: 0.55;}
  
    100%{opacity: 0;
      transform: scale(1.3,1.3);
    }
  }

  @media (min-width: 900px) {
    .heart-field{
      margin-left: 285px;
      transform: scale(1);
      bottom: 25%;
    }
  }

.yellow-trans{
  margin-left: 35%;
  bottom: 10%;
}

</style>